import {
  ARRANGE_VIEWING_TASK_DEFINITION,
  BUILD_WEDDING_WEBSITE_TASK_DEFINITION,
  MOBILE_ADD_COLLABORATOR_TASK_DEFINITION,
  MOBILE_MARK_AS_BOOKED_TASK_DEFINITION,
  EXPLORE_ADVICE_TASK_DEFINITION,
  EXPLORE_SUPPLIERS_TASK_DEFINITION,
  INVITES_AND_PAPER_TASK_DEFINITION,
  LOOK_INTO_WEDDING_INSURANCE_TASK_DEFINITION,
  REACH_OUT_SUPPLIERS_TASK_DEFINITION,
  REACH_OUT_VENUES_TASK_DEFINITION,
  SETUP_GIFT_LIST_TASK_DEFINITION,
  START_EXPLORING_VENUES_TASK_DEFINITION,
} from './task-definitions';

export type MobileFlowAssignment = 'venueSelected' | 'venueNotSelected';

export type MobileCtaType =
  | 'searchVenue'
  | 'searchVenueViewings'
  | 'searchSuppliers'
  | 'favouritesVenues'
  | 'favouritesSuppliers'
  | 'recommendedSuppliers'
  | 'website'
  | 'invitePartner'
  | 'giftList'
  | 'insuranceArticle'
  | 'invitesExternal'
  | 'advice';

export type MobileTaskMeta = {
  id: string;
  title: string;
  ctaText: string;
  ctaType: MobileCtaType;
  sessionsToComplete: number;
  completeOnClick?: boolean;
};

export const MOBILE_TASKS_BY_ID: Record<string, MobileTaskMeta> = {
  [START_EXPLORING_VENUES_TASK_DEFINITION.id]: {
    id: START_EXPLORING_VENUES_TASK_DEFINITION.id,
    title: 'Start exploring venues',
    ctaText: 'Take me there',
    ctaType: 'searchVenue',
    sessionsToComplete: 2,
  },
  [REACH_OUT_VENUES_TASK_DEFINITION.id]: {
    id: REACH_OUT_VENUES_TASK_DEFINITION.id,
    title: 'Reach out to your favourite venues',
    ctaText: "Let's go",
    ctaType: 'favouritesVenues',
    sessionsToComplete: 4,
  },
  [ARRANGE_VIEWING_TASK_DEFINITION.id]: {
    id: ARRANGE_VIEWING_TASK_DEFINITION.id,
    title: 'Arrange a viewing',
    ctaText: "Let's go",
    ctaType: 'searchVenueViewings',
    sessionsToComplete: 3,
  },
  [MOBILE_MARK_AS_BOOKED_TASK_DEFINITION.id]: {
    id: MOBILE_MARK_AS_BOOKED_TASK_DEFINITION.id,
    title: 'Find suppliers that work with your venue',
    ctaText: "Let's go",
    ctaType: 'recommendedSuppliers',
    sessionsToComplete: 2,
  },
  [EXPLORE_SUPPLIERS_TASK_DEFINITION.id]: {
    id: EXPLORE_SUPPLIERS_TASK_DEFINITION.id,
    title: 'Explore suppliers',
    ctaText: "Let's go",
    ctaType: 'searchSuppliers',
    sessionsToComplete: 2,
  },
  [REACH_OUT_SUPPLIERS_TASK_DEFINITION.id]: {
    id: REACH_OUT_SUPPLIERS_TASK_DEFINITION.id,
    title: 'Reach out to your favourite suppliers',
    ctaText: "Let's go",
    ctaType: 'favouritesSuppliers',
    sessionsToComplete: 4,
  },
  [BUILD_WEDDING_WEBSITE_TASK_DEFINITION.id]: {
    id: BUILD_WEDDING_WEBSITE_TASK_DEFINITION.id,
    title: 'Build your wedding website',
    ctaText: "Let's go",
    ctaType: 'website',
    sessionsToComplete: 2,
  },
  [MOBILE_ADD_COLLABORATOR_TASK_DEFINITION.id]: {
    id: MOBILE_ADD_COLLABORATOR_TASK_DEFINITION.id,
    title: 'Invite your partner',
    ctaText: "Let's go",
    ctaType: 'invitePartner',
    sessionsToComplete: 2,
  },
  [SETUP_GIFT_LIST_TASK_DEFINITION.id]: {
    id: SETUP_GIFT_LIST_TASK_DEFINITION.id,
    title: 'Set up your gift list',
    ctaText: "Let's go",
    ctaType: 'giftList',
    sessionsToComplete: 2,
  },
  [LOOK_INTO_WEDDING_INSURANCE_TASK_DEFINITION.id]: {
    id: LOOK_INTO_WEDDING_INSURANCE_TASK_DEFINITION.id,
    title: 'Look into wedding insurance',
    ctaText: "Let's go",
    ctaType: 'insuranceArticle',
    sessionsToComplete: 1,
    completeOnClick: true,
  },
  [INVITES_AND_PAPER_TASK_DEFINITION.id]: {
    id: INVITES_AND_PAPER_TASK_DEFINITION.id,
    title: 'Invites and paper products',
    ctaText: "Let's go",
    ctaType: 'invitesExternal',
    sessionsToComplete: 2,
    completeOnClick: true,
  },
  [EXPLORE_ADVICE_TASK_DEFINITION.id]: {
    id: EXPLORE_ADVICE_TASK_DEFINITION.id,
    title: 'Explore advice',
    ctaText: "Let's go",
    ctaType: 'advice',
    sessionsToComplete: Infinity,
  },
};

export const MOBILE_FLOW_TASK_IDS: Record<MobileFlowAssignment, string[]> = {
  venueNotSelected: [
    START_EXPLORING_VENUES_TASK_DEFINITION.id,
    REACH_OUT_VENUES_TASK_DEFINITION.id,
    ARRANGE_VIEWING_TASK_DEFINITION.id,
    MOBILE_MARK_AS_BOOKED_TASK_DEFINITION.id,
    BUILD_WEDDING_WEBSITE_TASK_DEFINITION.id,
    MOBILE_ADD_COLLABORATOR_TASK_DEFINITION.id,
    SETUP_GIFT_LIST_TASK_DEFINITION.id,
    LOOK_INTO_WEDDING_INSURANCE_TASK_DEFINITION.id,
    INVITES_AND_PAPER_TASK_DEFINITION.id,
    EXPLORE_ADVICE_TASK_DEFINITION.id,
  ],
  venueSelected: [
    EXPLORE_SUPPLIERS_TASK_DEFINITION.id,
    REACH_OUT_SUPPLIERS_TASK_DEFINITION.id,
    BUILD_WEDDING_WEBSITE_TASK_DEFINITION.id,
    MOBILE_ADD_COLLABORATOR_TASK_DEFINITION.id,
    SETUP_GIFT_LIST_TASK_DEFINITION.id,
    LOOK_INTO_WEDDING_INSURANCE_TASK_DEFINITION.id,
    INVITES_AND_PAPER_TASK_DEFINITION.id,
    EXPLORE_ADVICE_TASK_DEFINITION.id,
  ],
};
